// TODO: rename to Select2 or something
import * as $runtime from "../runtime.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import {getValue, getValues, initSelect2Impl, open, setValue, setValues} from "./foreign.js";
const initSelect2 = () => initSelect2Impl;
const group = Unsafe$dCoerce.unsafeCoerce;
const fromSingleOption = dictToOptionId => opt => ({id: dictToOptionId.toOptionId(opt.key), option: opt.key, text: opt.label});
const entry = Unsafe$dCoerce.unsafeCoerce;
const fromSelectOptions = dictToOptionId => Data$dFunctor.arrayMap(v => {
  if (v.tag === "OptGroup") {
    return {text: v._1.label, children: Data$dFunctor.arrayMap(opt => ({id: dictToOptionId.toOptionId(opt.key), option: opt.key, text: opt.label}))(v._1.options)};
  }
  if (v.tag === "SingleOption") { return {id: dictToOptionId.toOptionId(v._1.key), option: v._1.key, text: v._1.label}; }
  $runtime.fail();
});
export {entry, fromSelectOptions, fromSingleOption, group, initSelect2};
export * from "./foreign.js";
